import { render, staticRenderFns } from "./EditPdp.vue?vue&type=template&id=3a8c88f8&scoped=true"
import script from "./EditPdp.ts?vue&type=script&lang=ts&external"
export * from "./EditPdp.ts?vue&type=script&lang=ts&external"
import style0 from "./EditPdp.vue?vue&type=style&index=0&id=3a8c88f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8c88f8",
  null
  
)

export default component.exports